import * as React from 'react';

const ChequeRebrandingSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={36} height={32} viewBox="0 0 192 128" fill="none" {...props}>
        <path
            d="M164 14.546L149.455 0l-24.001 24H4a4 4 0 00-4 4v88a4 4 0 004 4h184a4 4 0 004-4V28a4 4 0 00-4-4h-25.455l-8 8H184v80H8V32h109.454l-8.727 8.727L100 64l23.273-8.727L164 14.546z"
            fill="#000"
        />
        <path
            d="M96 60H24v4h72v-4zM168 76v4H24v-4h144zM168 100h-68v4h68v-4zM132 60h36v4h-36v-4zM100 94.584l2.585-2.585L100 89.414 101.414 88l2.585 2.585L106.584 88l1.414 1.414L105.413 92l2.585 2.585-1.414 1.414-2.585-2.585-2.585 2.585L100 94.584z"
            fill="#000"
        />
    </svg>
);

ChequeRebrandingSvg.displayName = 'ChequeRebrandingSvg';
export default ChequeRebrandingSvg;
